import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  postalCode: string;
};

export type AddressData = {
  city: string;
  state: string;
  country: string;
  street: string;
  district: string;
  cep: string;
  ibgeCode: string;
  type: string;
  description: string | null;
};

export type Response = {
  data: AddressData;
};

const getAddressByPostalCode: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { postalCode } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/address/{postalCode}',
      {
        ...options,
        params: {
          postalCode,
        },
      }
    );

    return response;
  };

export default getAddressByPostalCode;
